/**
 * Bucket a list of events by local calendar date and return exactly `days`
 * entries (oldest → newest) ending at `now`'s local date, zero-filled.
 *
 * Pure function — no imports, no side-effects.
 */
export function eventsPerDay(
  events: { created_at: string }[],
  days: number,
  now: Date,
): { date: string; count: number }[] {
  // Build the window of YYYY-MM-DD keys from (now - (days-1)) .. now
  const window: string[] = []
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - i)
    window.push(localDateKey(d))
  }

  // Zero-fill map
  const counts: Record<string, number> = {}
  for (const key of window) counts[key] = 0

  // Bucket events
  for (const ev of events) {
    const ts = new Date(ev.created_at)
    if (isNaN(ts.getTime())) continue
    const key = localDateKey(ts)
    if (key in counts) counts[key]++
  }

  return window.map(date => ({ date, count: counts[date] }))
}

/** Format a Date as a local YYYY-MM-DD string (zero-padded). */
function localDateKey(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}
